import * as React from 'react'

import {
  type BulkCreateAdditionalCompensationsPageEmployeeFragment,
  BulkCreateAdditionalCompensationsPageDocument,
} from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import BulkCreateAdditionalCompensationsRevamp from 'modules/employees/pages/BulkCreateAdditionalCompensationsPage/BulkCreateAdditionalCompensationsRevamp'

type Props = {
  employeeIds: string[]
  onClose: () => void
  onSuccess: () => void
}

const BulkCreateAdditionalCompensationsWizardModal = ({
  employeeIds,
  onClose,
  onSuccess,
}: Props) => {
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { data, loading } = useQuery(BulkCreateAdditionalCompensationsPageDocument, {
    variables: {
      companyId,
      employeeIds,
    },
    skip: employeeIds.length === 0,
  })

  if (loading || !data) {
    return null
  }

  const payrollConcepts = data.payroll?.conceptsConnection?.nodes ?? []
  const disabledPayrollConceptIds =
    data.compensations?.payrollConceptStatusesConnection?.nodes
      .filter((status) => !status.enabled)
      .map((status) => status.payrollConceptId) ?? []

  const revampPayrollConcepts = payrollConcepts.filter(
    (concept) => !disabledPayrollConceptIds.includes(concept.id)
  )

  const contracts =
    data.contracts?.referenceContractsConnection?.nodes.filter(
      (contract) => contract._policies?.edit.can ?? false
    ) ?? []

  const selectedEmployees: BulkCreateAdditionalCompensationsPageEmployeeFragment[] = contracts.map(
    (contract) => contract.employee
  )

  return (
    <BulkCreateAdditionalCompensationsRevamp
      companyId={String(companyId)}
      contracts={contracts}
      selectedEmployees={selectedEmployees}
      payrollConcepts={revampPayrollConcepts}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  )
}

export default BulkCreateAdditionalCompensationsWizardModal
